import { useNavigate } from "react-router-dom";
import DispositionPenaltyFlag from "./DispositionPenaltyFlag";
import { useDispatch, useSelector } from "react-redux";
import { operations } from 'redux/Navigation'
import { getDispositionPenaltyFlagSave, setDispositionPenaltyFlagSave } from "Store/OrderManagement/DispositionPenalityFlag/DispositionPenalityFlagAction";
import { useCallback, useEffect, useState } from "react";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import { getPenaltyGlobalFlag } from "Store/OrderManagement/DispositionPenaltyFee/DispositionPenaltyFeeAction";
import permissions, { isAuthorized } from "client/utils/Permissions";

const DispositionPenaltyFlagContainer = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const navDispatch = operations.dispatchNav(dispatch);
  const dispatchHeaderNav = operations.dispatchHeaderNav(dispatch);
  const [globalPenaltyFlagTemp, setGlobalPenaltyFlagTemp] = useState<any>();
  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const {
    globalPenaltyFlag,
    getUserDetails,
    isDispositionPenaltyFlagSaved
  }: any = useSelector((state: any) => ({
    globalPenaltyFlag: state.DispositionPenaltyFeeReducer.globalPenaltyFlag,
    getUserDetails: state.UserProfile.getUserDetails,
    isDispositionPenaltyFlagSaved: state.DispositionPenaltyFlagReducer.isDispositionPenaltyFlagSaved
  }));

  const pageNavigation = () => {
    if(!isAuthorized(permissions.ViewAdmin) && getUserDetails?.emailId){
      Navigate('/ordermanagement/blank');
    }else{
      dispatch(getPenaltyGlobalFlag())
      navDispatch("Admin");
      dispatchHeaderNav("Admin");
    }
  } 

  useEffect(() => {
    pageNavigation()
  }, [])

  useEffect(() => {
    pageNavigation()
  }, [getUserDetails?.emailId])

  useEffect(() => {
    setGlobalPenaltyFlagTemp(globalPenaltyFlag)
  }, [globalPenaltyFlag])

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  useEffect(() => {
    if(isDispositionPenaltyFlagSaved && isDispositionPenaltyFlagSaved != null){
      let popUpDecriptionTxt = "Disposition Penalty Flag saved successfully."
      setPopupcontent({
        ...Popupcontent,
        titleImg: SuccessBee,
        title: 'SUCCESS',
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: popUpDecriptionTxt,
        primaryBtnText: "",
        outlineBtnText: "Close",
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setDispositionPenaltyFlagSave(null))
        },
        isSingleConfirmationBtn: true,
      });
    }else if(!isDispositionPenaltyFlagSaved && isDispositionPenaltyFlagSaved != null){
      let popUpDecriptionTxt = "Error occured while saving Disposition Penalty Flag."
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: 'INFORMATION',
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: popUpDecriptionTxt,
        primaryBtnText: "",
        outlineBtnText: "Close",
        popupOutlinebtnOnclick: () => {
          hideDialog();
          dispatch(setDispositionPenaltyFlagSave(null))
        },
        isSingleConfirmationBtn: true,
      });
    }
  },[isDispositionPenaltyFlagSaved])

  const breadcrumlist = [
    { text: 'Admin Settings', key: 'f1', href: '/ordermanagement', onClick: (e: any) => { e.preventDefault(); Navigate('/ordermanagement'); navDispatch('Admin'); dispatchHeaderNav('Admin'); } },
    { text: "Disposition Penalty Flag", key: "f2" },
    {}
  ]



  const handleClickBack = () => {
    Navigate('/ordermanagement')
  }

  const onFlagChange = (e?: any, item?: any) => {
    setGlobalPenaltyFlagTemp(item)
    let payload = {
      dispositionPenaltyFlag: item,
      savedBy: getUserDetails?.emailId
    }
    dispatch(getDispositionPenaltyFlagSave(payload))
  }

  return (
    <DispositionPenaltyFlag
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      globalPenaltyFlag={globalPenaltyFlagTemp}
      onFlagChange={onFlagChange}
      Popupcontent = {Popupcontent}
      hideDialog = {hideDialog}
    />
  )
}

export default DispositionPenaltyFlagContainer;